




































































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';
import { log } from 'util';

import Requester from '../../requester';

import { ConsultaColetiva } from '../../../../back/src/entity/ConsultaColetiva';
import { ResponseObj, TipoConsultaColetiva } from '../../../../back/src/types';
import { Paciente } from '../../../../back/src/entity/Paciente';

import ConsultaColetivaAlert from '../../components/consultas_coletivas/ConsultaColetivaAlert.vue';
import TheConsultasColetivasCriarAlterarDialog from '../../components/consultas_coletivas/TheConsultasColetivasCriarAlterarDialog.vue';
import ThePacientesResumo from '../../components/pacientes/ThePacientesResumo.vue';
import CustomDialog from '../../components/CustomDialog.vue';
import ConsultasColetivasDataTable from '../../components/consultas_coletivas/ConsultasColetivasDataTable.vue';
import TheConsultaColetivaDados from '../../components/consultas_coletivas/TheConsultaColetivaDados.vue';
import ThePacientesObservacoesAlert from '../../components/pacientes/ThePacientesObservacoesAlert.vue';

export default Vue.extend({
  name: 'ConsultasColetivasIndex',
  components: {
    TheConsultasColetivasCriarAlterarDialog,
    ConsultaColetivaAlert,
    ThePacientesResumo,
    CustomDialog,
    ConsultasColetivasDataTable,
    TheConsultaColetivaDados,
    ThePacientesObservacoesAlert,
  },
  data() {
    return {
      pacienteSelecionada: null,
      dialogResumoPaciente: false,
      dialogDadosConsultaColetiva: false,
      dialogAlterarConsultaColetiva: false,
      loading: false,
      TipoConsultaColetiva,
      dataBusca: '',
      menuDataBusca: false,
      listaConsultasColetivas: [],
      consultaColetivaSelecionada: Object as () => ConsultaColetiva,
      consultaColetivaAlterar: null,
      tab: 0,
      tabs: [
        { titulo: 'Agendadas', tipo: TipoConsultaColetiva.A },
        { titulo: 'Finalizadas', tipo: TipoConsultaColetiva.F },
        { titulo: 'Canceladas', tipo: TipoConsultaColetiva.C },
      ],
    };
  },
  async mounted() {
    await this.buscaConsultasColetivas(this.tabs[this.tab].tipo);
  },
  computed: {
    dataBuscaFormatada(): string {
      if (this.dataBusca) {
        const momentdataBusca = moment(this.dataBusca);
        if (momentdataBusca.isValid()) {
          return momentdataBusca.format('DD/MM/YYYY');
        }
      }
      return '';
    },
  },
  methods: {
    async buscaConsultasColetivas(tipo: TipoConsultaColetiva) {
      this.loading = true;
      this.menuDataBusca = false;
      const queryObj: any = {
        tipo,
      };
      if (this.dataBusca.length > 0) {
        queryObj.data = this.dataBusca;
      }
      try {
        const response = await Requester.consultaColetiva.buscaConsultasColetivas(queryObj);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.listaConsultasColetivas = _.orderBy(response.data.registros, ['datetime_agendamento'], ['asc']);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    exibeResumoPaciente(paciente: Paciente) {
      this.pacienteSelecionada = paciente;
      this.dialogResumoPaciente = true;
    },
    limpaBusca() {
      this.dataBusca = '';
      this.buscaConsultasColetivas(this.tabs[this.tab].tipo);
    },
    mostrarDadosConsultaColetiva(consultaColetiva) {
      this.consultaColetivaSelecionada = consultaColetiva;
      this.dialogDadosConsultaColetiva = true;
    },
    alterarConsultaColetiva(consultaColetiva: ConsultaColetiva) {
      this.$refs.TheConsultaColetivaCriarAlterarDialog.abrirDialog(consultaColetiva);
    },
  },
  watch: {
    async tab(novaTab) {
      await this.buscaConsultasColetivas(this.tabs[novaTab].tipo);
    },
  },
});
